import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import EmpProfitability from "./empProfitability";
export default function EmployeeProfitability() {
  return (
    <DashboardLayout>
      <EmpProfitability />
    </DashboardLayout>
  );
}
